import DashboardOrchestrationService from "../../services/dashboard-orchestration-service-api";
import EventService from "../../services/event-service-api";
import DashboardOrchService from "../../services/dashboard-orchestration-service-api";

const uploadDocs = async (data) => {
  try {
    const response = await DashboardOrchestrationService.uploadDocs(data);

    if (response?.status) {
      return {
        status: response.status,
        data: response.data,
        headers: response.headers,
      };
    } else {
      return {
        status: 200,
        data: response,
      };
    }
  } catch (err) {
    return {
      status: err?.response?.status || 500,
      data: err?.response?.data || { message: err.message },
    };
  }
};
const getAllDocuments = (searchObject) => {
    return DashboardOrchService.getDocList(searchObject)
      .then((response) => {
        if (!!response) {
          if (response.dashboardItem.length > 0) {
            let activeDocs = response.dashboardItem.filter((item) => item.isDeleted != true);
            let allDocs = activeDocs.sort(function (a, b) {
              return Date.parse(b.createdOn) - Date.parse(a.createdOn);
            });
            return response.dashboardItem;
          }
          return response;
        }
        return response;
      })
      .catch((error) => console.log("Error"));
  };


const postEventMethod = async (eventType, eventSubType, actorId, topicName, data) => {
  try {
    const response = await EventService.postEventDataV2(eventType, eventSubType, actorId, topicName, data);
    return response;
  } catch (err) {
    console.error("postEventMethod failed:", err);
    throw err;
  }
};
const permanentDeleteDocs = async (data) => {
  try {
    const response = await DashboardOrchestrationService.updateDocumentAction(data);
    return response;
  } catch (err) {
    console.error("postEventMethod failed:", err);
    throw err;
  }
};
export { postEventMethod, uploadDocs, getAllDocuments, permanentDeleteDocs };